import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { paths as studioPaths } from 'studio/App/Studio/Studio';
import { queryParameterNames } from 'studio/pages/Editor/Editor';

/**
 * Hook that returns a function to open a file in the editor and optionally jump to a specific concept
 * @returns {Function} open - Function that takes a file path and optional vklQualifiedIdentifier
 */
export const useEditorOpen = () => {
  const location = useLocation();
  const history = useHistory();

  return useCallback(
    (path, vklQualifiedIdentifier) => {
      // set the URL jumpTo param to trigger opening the file with the specified path and jumping to the specified identifier
      const params = new URLSearchParams(location.search);
      const currentFile = params.get(queryParameterNames.file);
      const currentConcept = params.get(queryParameterNames.concept);
      params.set(queryParameterNames.file, path);
      if (vklQualifiedIdentifier) {
        params.set(queryParameterNames.concept, vklQualifiedIdentifier);
      } else {
        params.delete(queryParameterNames.concept);
      }

      const newLocation = { pathname: studioPaths.editor, search: params.toString() };
      path === currentFile && vklQualifiedIdentifier === currentConcept
        ? history.replace(newLocation)
        : history.push(newLocation);
    },
    [location, history]
  );
};
